<template>
  <div class="v-brand pt--4">
    <div class="container v-brand__content">
      <a href="/">
        <img src="@/assets/logo.png" alt="Serwis Dealera BMW Inchcape Wrocław" class="v-brand__logo" />
      </a>
      <h1 class="mt--2" v-if="getDealers">
        Serwis Dealera BMW Inchcape
        <template v-if="lead.dealer_id && getDealers.find((e) => e.id == lead.dealer_id)">
          {{
        getDealers != [] && lead.dealer_id != ""
          ? " " + getDealers.find((e) => e.id == lead.dealer_id).city
          : ""
      }}
        </template>
      </h1>
      <h2 class="mt--5">
        Serdecznie witamy w Twoim systemie planowania wizyt serwisowych.
      </h2>
      <div class="flex-row">
        <div v-for="brand in getBrands" class="v-brand__tile">
          <img :src="brand.image" :alt="brand.name">
          <button class="btn btn--primary mt--1 v-brand__btn"
            v-on:click="lead.brand_val = brand.val; $router.push('/service')">{{ brand.name }}</button>
        </div>

      </div>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/footer.vue";
import Header from "@/components/header.vue";

import { mapGetters, mapActions } from "vuex";
import lead from "../mixins/lead.js";

export default {
  name: "home",
  mixins: [lead],
  components: {
    Footer,
    Header,
  },
  computed: {
    ...mapGetters({
      getBrands: "definitions/getBrands",
      getDealers: "definitions/getDealers",
    }),
  },
  methods: {
    ...mapActions({
      fetchDealers: "definitions/fetchDealers",
    }),
  },
  mounted() {
    if (this.$route.query) {
      let routeParams = this.$route.query;
      this.fetchDealers();
      if (this.$route.query.dealer_id) {
        routeParams.dealer_id = Number(routeParams.dealer_id);
      }
      this.lead = { ...this.lead, ...routeParams };
      if (this.$route.query.aplikacja) {
        this.lead.mobile_app = 1;
      }

      // Pobieram UTM'y se
      if(routeParams.utm_source) {
        this.lead.utm_source = routeParams.utm_source;
      }

      if(routeParams.utm_medium) {
        this.lead.utm_medium = routeParams.utm_medium;
      }

      if(routeParams.utm_campaign) {
        this.lead.utm_campaign = routeParams.utm_campaign;
      }


    }
  },
};
</script>
<style lang="scss">
.v-brand {
  &__content {
    min-height: calc(100vh - 180px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  &__logo {
    max-width: 100px;
    height: auto;
  }

  &__btn {
    min-width: 268px;
  }

  &__select {
    max-width: 400px;

    &--highlight {
      cursor: pointer;

      .select-placeholder {
        animation: blinkBg 2s infinite;
        color: #fff;
        border: 0;
      }
    }
  }

  &__tile {
    height: 200px;
    display: flex;
    justify-content: space-evenly;
    flex-direction: column;
    background-color: $brightgray;
    padding: 1rem;
    margin: 1rem;

    img {
      max-height: 80px;
      max-width: 200px;
      margin: 0 auto;
    }
  }
}

@keyframes blinkBg {
  0% {
    background-color: $orange;
    color: $white;
  }

  50% {
    background-color: $white;
    color: $black;
  }

  100% {
    background-color: $orange;
    color: $white;
  }
}
</style>
